<mat-card style="padding-bottom: 10px;">
  <app-matspinner *ngIf="isLoading"></app-matspinner>
  <mat-card-header>
    <mat-card-title class="title">Add Pharmacy Chain</mat-card-title>
  </mat-card-header>
  <mat-divider class="divider"></mat-divider>
  <mat-card-content>
    <br>
    <div class="container">
      <form [formGroup]="form">
        <!-- Row 1: Name & Billing Group -->
        <div class="row form-row">
          <div class="col-md-2">
            <label class="lbl_fld">Name</label><span class="asterick">*</span>
          </div>
          <div class="col-md-4">
            <mat-form-field class="ffs" appearance="outline">
              <input
                matInput
                type="text"
                formControlName="PharmacyName"
                placeholder="Name (Max length is 50 characters)"
                required
                (keyup)="clearPharmacyNameDuplicateValidation();"
                autocomplete="off"
              >
              <mat-error *ngIf="form.get('PharmacyName')?.invalid && (form.get('PharmacyName')?.touched || form.get('PharmacyName')?.dirty)">
                {{errorMessageForPharmacyName}}
              </mat-error>
            </mat-form-field>
          </div>


          <div class="col-md-2 right-shift">
            <label class="lbl_fld">Billing Group</label>
          </div>


          <div class="col-md-4">
            <mat-form-field class="ffs" appearance="outline">
              <input
                matInput
                type="text"
                formControlName="BillingGroup"
                placeholder="Billing Group (Max length is 4 characters)"
                (change)="onBillingGroupChange($event)"
                autocomplete="off"
              >
              <mat-error *ngIf="form.get('BillingGroup')?.invalid && (form.get('BillingGroup')?.touched || form.get('BillingGroup')?.dirty)">
                {{errorMessageForBillingGroup}}
              </mat-error>
            </mat-form-field>
          </div>


        </div>
        <!-- Row 2: Vela PID & Billing Region -->
        <div class="row form-row">
          <div class="col-md-2">
            <label class="lbl_fld">Vela PID</label><span class="asterick">*</span>
          </div>
          <div class="col-md-4">
            <mat-form-field class="ffs" appearance="outline">
              <input
                matInput
                type="text"
                formControlName="PID"
                placeholder="Vela PID (Max length is 20 characters)"
                (keyup)="clearPIDDuplicateValidation();"
                autocomplete="off"
              >
              <mat-error *ngIf="form.get('PID')?.invalid && (form.get('PID')?.touched || form.get('PID')?.dirty)">
                {{errorMessageForPID}}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-2 right-shift">
            <label class="lbl_fld">Billing Region</label>
          </div>
          <div class="col-md-4">
            <mat-form-field class="ffs" appearance="outline">
              <input
                matInput
                type="text"
                formControlName="BillingRegion"
                placeholder="Billing Region (Max length is 2 characters)"
                (change)="onBillingRegionChange($event)"
                autocomplete="off"
              >
              <mat-error *ngIf="form.get('BillingRegion')?.invalid && (form.get('BillingRegion')?.touched || form.get('BillingRegion')?.dirty)">
                {{errorMessageForBillingRegion}}
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <!-- Row 3: Activation Date & Vendor -->
        <div class="row form-row">
          <div class="col-md-2">
            <label class="lbl_fld">Activation Date</label><span class="asterick">*</span>
          </div>
          <div class="col-md-4" style="position:relative;">
            <mat-form-field class="ffs" appearance="outline">
              <input
                matInput
                name="EffectiveDate"
                [matDatepicker]="effpicker"
                formControlName="EffectiveDate"
                (dateChange)="onDateSelect($event)"
                (keyup)="onDateInputkeyup($event)"
                required
                placeholder="MM/DD/YYYY"
                [min]="minEffectiveDate"
                autocomplete="off"
              >
              <mat-datepicker-toggle matSuffix [for]="effpicker"></mat-datepicker-toggle>
              <mat-datepicker #effpicker></mat-datepicker>
              <mat-error *ngIf="form.get('EffectiveDate')?.invalid && (form.get('EffectiveDate')?.touched || form.get('EffectiveDate')?.dirty)">
                {{errorMessageForEffectiveDate}}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-2 right-shift">
            <label class="lbl_fld">Vendor</label><span class="asterick">*</span>
          </div>
          <div class="col-md-4">
            <mat-form-field class="ffs" appearance="outline">
              <mat-select
                formControlName="Vendor"
                required
                id="Vendor"
                placeholder="Select Vendor"
                (selectionChange)="onVendorChange($event.value)"
              >
                <mat-option value="" disabled>Select Vendor</mat-option>
                <mat-option *ngFor="let vendor of vendorList" [value]="vendor.VendorId">{{vendor.VendorName}}</mat-option>
              </mat-select>
              <mat-error *ngIf="form.get('Vendor')?.invalid && (form.get('Vendor')?.touched || form.get('Vendor')?.dirty)">
                {{errorMessageForVendor}}
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <!-- Row 4: Deactivation Date & Pet Transactions -->
        <div class="row form-row">
          <div class="col-md-2">
            <label class="lbl_fld">Deactivation Date</label>
          </div>
          <div class="col-md-4" style="position:relative;">
            <mat-form-field class="ffs" appearance="outline">
              <input
                matInput
                name="TermDate"
                [matDatepicker]="termpicker"
                formControlName="TermDate"
                (dateChange)="onDateSelect($event)"
                (keyup)="onDateInputkeyup($event)"
                placeholder="MM/DD/YYYY"
                [min]="minTermDate"
                autocomplete="off"
              >
              <mat-datepicker-toggle matSuffix [for]="termpicker"></mat-datepicker-toggle>
              <mat-datepicker #termpicker></mat-datepicker>
              <mat-error *ngIf="form.get('TermDate')?.invalid && (form.get('TermDate')?.touched || form.get('TermDate')?.dirty)">
                {{errorMessageForTermDate}}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-3 right-shift">
            <label class="lbl_fld">Pet Transactions Enabled</label>
          </div>
          <div class="col-md-3" style="padding-top: 12px;">
            <mat-checkbox color="primary" style="transform: scale(1.64); margin-top: -20px; margin-left: -80px;" formControlName="PetEnabled"></mat-checkbox>
          </div>
        </div>


<!-- Row 5: Form Mode Selection -->
<div class="row form-row">
  <div class="col-md-2">
    <label class="lbl_fld">Connectivity Mode</label>
  </div>
  <div class="col-md-6">
    <div class="button-toggle" style="gap: 8%;">
      <button type="button"
        [class.active]="useVendorLevelConnectivity === false"
        (click)="toggleVendorLevelConnectivity(false)">
        Pharmacy-Level Connectivity
      </button>
      <button type="button" 
        [class.active]="useVendorLevelConnectivity === true"
        (click)="toggleVendorLevelConnectivity(true)">
        Vendor-Level Connectivity
      </button>
    </div>
  </div>
</div>


        




        <mat-divider class="divider" style="margin-top: 2%;margin-bottom: 2%;" *ngIf="!useVendorLevelConnectivity"></mat-divider>
        <app-connection-details *ngIf="!useVendorLevelConnectivity" [inputModel]="pharmacyModel">
        </app-connection-details>
        <br>
        <div class="form-actions-row" style="display: flex; justify-content: center;">
          <button mat-raised-button color="primary" class="btn-save"
            [disabled]="isUpdateButtonDisabled()"
            (click)="submitForm()">Save</button>
          <button mat-raised-button color="primary" class="btn-cancel" (click)="onClickCancel()">Cancel</button>
        </div>
      </form>
    </div>
  </mat-card-content>
  <br>
  <br>
</mat-card>